import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";
import { AddressSchema } from "./team";

export enum AddressType {
  CUSTOM = "custom",
}

export const addressTypeSchema = z.enum(AddressType);

export const AddressCollectionSchema_ = z.object({
  _id: zExt.objectId(),
  team: zExt.objectId(),
  type: addressTypeSchema,
  address: AddressSchema,
});

export const AddressCollectionSchema: z.ZodType<AddressCollection> =
  AddressCollectionSchema_;
export interface AddressCollection
  extends z.infer<typeof AddressCollectionSchema_> {}

export const CreateAddressCollectionSchema = AddressCollectionSchema_.omit({
  _id: true,
});

export interface CreateAddressCollectionInput
  extends z.infer<typeof CreateAddressCollectionSchema> {}

export const UpdateAddressCollectionSchema = AddressCollectionSchema_.omit({
  _id: true,
  team: true,
}).partial();
export interface UpdateAddressCollectionInput
  extends z.infer<typeof UpdateAddressCollectionSchema> {}
